import { IS_SIDEBAR_OPEN_LS } from '../../constants/localStorage';

export function getSidebarDefaultState() {
  return localStorage.getItem(IS_SIDEBAR_OPEN_LS) === 'true';
}
